export type ShareNetwork = 'x' | 'threads' | 'facebook' | 'linkedin' | 'reddit'

const MAX_TEXT_LENGTH = 200

export function toShareText(raw: unknown, fallback: string): string {
    const text = typeof raw === 'string' ? raw.trim() : ''
    return text ? Array.from(text).slice(0, MAX_TEXT_LENGTH).join('') : fallback
}

const intent = (base: string, params: Record<string, string>) => `${base}?${new URLSearchParams(params)}`

export function buildShareLinks(text: string, url: string): Record<ShareNetwork, string> {
    const post = `${text} ${url}`

    return {
        x: intent('https://x.com/intent/post', { text: post }),
        threads: intent('https://www.threads.com/intent/post', { text: post }),
        facebook: intent('https://www.facebook.com/sharer/sharer.php', { u: url }),
        linkedin: intent('https://www.linkedin.com/sharing/share-offsite/', { url }),
        reddit: intent('https://www.reddit.com/submit', { url, title: text }),
    }
}
